export function sharePopup() {
    $('a.js-share').click(function(e){
        e.preventDefault();
        let $link   = $(this);
        let href    = $link.attr('href');
        let network = $link.attr('data-network');

        let networks = {
            facebook : { width : 600, height : 300 },
            twitter  : { width : 600, height : 254 },
            google   : { width : 515, height : 490 },
            linkedin : { width : 600, height : 473 }
        };

        let popup = function(network){
            var options = 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,';
            window.open(href, '', options+'height='+networks[network].height+',width='+networks[network].width);
        };

        popup(network);
    });
}


// WEBPACK FOOTER //
// ./resources/js/utils/share.js